module.exports = __webpack_public_path__ + "media/images/app/testimonials/carousel-second-d2c9bff90b39b1ac587ea7e9013863bb.webp";